export const RECOMMENDATION_PERCENTAGE_THRESHOLDS = {
  highlyRecommended: 90,
  recommended: 75,
  conditionallyRecommended: 60,
  limitedFit: 40,
} as const;
